require('jquery');
var angular = require('angular');
var _module = require('./index');


_module.directive('markActive', [
    function() {
        return {
            restrict: 'A',
            link: function($scope, elem, attrs) {
                $scope.$watch(attrs.markActive, function(newValue, oldValue) {
                    if(!isNaN(newValue)) {
                        children = elem.children();
                        children.removeClass('active');
                        $(children[newValue]).addClass('active');
                    }
                });
            }
        };
    }
]);